import { supabase } from "../lib/supabase";

async function requireSessionToken() {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error) throw error;
  if (!session?.access_token) {
    throw new Error("You must be signed in to continue.");
  }

  return session.access_token;
}

async function invokeOpsFunction(functionName, body) {
  const accessToken = await requireSessionToken();

  const { data, error } = await supabase.functions.invoke(functionName, {
    body,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (error) throw error;
  if (data?.error) throw new Error(data.error);

  return data;
}

export function completeServiceBooking(payload) {
  return invokeOpsFunction("complete-service-booking", payload);
}

export function raiseBookingDispute(payload) {
  return invokeOpsFunction("raise-booking-dispute", payload);
}

export function runWeeklyPayouts(payload) {
  return invokeOpsFunction("run-weekly-payouts", payload);
}
